import { useState } from 'react';
import { SegmentedControl } from '@components/SegmentedControl';
import { IconDoNotDisturb, IconRemoveCircle, IconCheckCircle } from '@components/icons';
import { SectionHeader } from './shared';
import styles from '../DemoPage.module.scss';

const ratingSegments = [
  { value: 'not-ok', icon: <IconDoNotDisturb size={18} />, ariaLabel: 'Not OK' },
  { value: 'neutral', icon: <IconRemoveCircle size={18} />, ariaLabel: 'Neutral' },
  { value: 'ok', icon: <IconCheckCircle size={18} />, ariaLabel: 'OK' },
];

export const SegmentedControlSection = () => {
  const [value, setValue] = useState('neutral');

  return (
    <section className={styles.section}>
      <SectionHeader
        title="Segmented Control"
        description="A 3-state toggle control for mutually exclusive selections. Used for lead rating in the Manage Leads action bar."
        styles={styles}
      />

      <div className={styles.subsection}>
        <h3 className={styles.subsectionTitle}>Interactive Demo</h3>
        <div className={styles.row}>
          <SegmentedControl segments={ratingSegments} value={value} onChange={setValue} />
          <span className={styles.hint} style={{ marginLeft: 12 }}>
            Selected: <strong>{value}</strong>
          </span>
        </div>
      </div>

      <div className={styles.subsection}>
        <h3 className={styles.subsectionTitle}>Each State Active</h3>
        <div className={styles.row} style={{ gap: 24 }}>
          <div>
            <SegmentedControl segments={ratingSegments} value="not-ok" onChange={() => {}} />
            <p className={styles.hint}>Not OK</p>
          </div>
          <div>
            <SegmentedControl segments={ratingSegments} value="neutral" onChange={() => {}} />
            <p className={styles.hint}>Neutral</p>
          </div>
          <div>
            <SegmentedControl segments={ratingSegments} value="ok" onChange={() => {}} />
            <p className={styles.hint}>OK</p>
          </div>
        </div>
      </div>

      <div className={styles.subsection}>
        <h3 className={styles.subsectionTitle}>Disabled</h3>
        <div className={styles.row}>
          <SegmentedControl segments={ratingSegments} value="neutral" onChange={() => {}} disabled />
        </div>
        <p className={styles.hint}>Disabled state with reduced opacity and no interaction.</p>
      </div>
    </section>
  );
};
